module.exports = __webpack_public_path__ + "img/pic_chahua.4776728c.png";